import React from 'react';

import { StepProps, track } from '@betterment/js-runtime';
import { Text } from '@betterment/samba-react';
import { Box, Button, ErrorText, FormikDropdown, Heading, InputGroup } from '@betterment/style-closet-react';
import { ErrorMessage, Form, Formik } from 'formik';
import * as Yup from 'yup';

import { CustomerSignupValues } from './Controller';

import { CheckingSignupData } from '../Shared/data';
import { WorkflowLayout } from '../Shared/layout/WorkflowLayout';

export interface Props extends StepProps<CustomerSignupValues> {
  checkingSignupData: CheckingSignupData;
  handleClose: () => void;
}

const StepSchema = Yup.object<{ value: string }>().shape({
  value: Yup.string().required('Occupation cannot be blank'),
});

const Occupation: React.FC<React.PropsWithChildren<Props>> = ({
  flowState,
  goToNextStep,
  goToPreviousStep,
  checkingSignupData,
  handleClose,
}) => {
  const { stepTitle, role: initialValue } = flowState.values;

  const handleSubmit = ({ value }: { value: string }) => {
    track('ElementClicked', { name: 'Continue', flow: 'OpenCheckingAccount' });
    goToNextStep({ role: value });
  };

  return (
    <WorkflowLayout
      feature="checking_customer_signup"
      pageTitle="Sign up - Checking"
      workflowTitle={stepTitle}
      onBack={goToPreviousStep}
      onClose={handleClose}
    >
      <Heading variant="primary">Tell us about your employment.</Heading>
      <Box my="8">
        <Text
          as="p"
          color="text"
          css={{
            marginBottom: 'space.300',
          }}
        >
          We're required by our regulators to collect this information.
        </Text>
      </Box>
      <Formik
        onSubmit={handleSubmit}
        validationSchema={StepSchema}
        initialValues={{ value: initialValue || '' }}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ isSubmitting }) => (
          <Form>
            <InputGroup maxWidth="100%">
              <FormikDropdown
                items={checkingSignupData.roleOptions.map(value => ({ value }))}
                name="value"
                labelText="Occupation"
                placeholder="Select..."
                mb={1}
              />
              <ErrorMessage name="role" component={ErrorText} />
            </InputGroup>
            <Button type="submit" disabled={isSubmitting}>
              Continue
            </Button>
          </Form>
        )}
      </Formik>
    </WorkflowLayout>
  );
};

export default Occupation;
